import { _ as __rest } from './tslib.es6-b97b9ccd.js';
import React__default from 'react';
import './index-ed1b642a.js';
import '@mantine/core';
import '@mantine/dates';
import './index-d722456d.js';
import './index-57001be3.js';
import './index-2bf5f78a.js';
import './useMantineLocale-738fc2b0.js';
import { T as Text$1 } from './index-5c0e8412.js';
import './index-966f3431.js';
import './index.styles-2ae2bbf8.js';
import './translationsContext-f94ca99c.js';
import '@mantine/hooks';
import './utils-1a4cbdae.js';
import './other-cef0261a.js';
import './index-6a7dde31.js';

/**
 * @deprecated Consider to use import { Text } from '@hhgtech/hhg-components/mantine'
 */
const Text = (_a) => {
    var { size = 'base', type = 'regular' } = _a, rest = __rest(_a, ["size", "type"]);
    return (React__default.createElement(Text$1, Object.assign({ size: size, weight: type === 'caption' ? 'bold' : type, "data-size": size, "data-type": type, "data-word-wrap": rest.wordWrap, "data-is-uppercase": rest.isUppercase }, rest)));
};

export { Text as T };
